module.exports = __webpack_public_path__ + "static/media/UserJourney.30946a7f.png";